import React from 'react';
import PropTypes from 'prop-types';
import { Detail, Input } from 'components/common';

function ProductInfo({
  productName,
  productDescription,
  meetingTime,
  showMeetingTime,
  onProductNameChange,
  onProductDescriptionChange,
  onMeetingTimeChange,
  loading,
}) {
  return (
    <>
      <Detail label='Product Name' style={{ marginBottom: '8px' }}>
        <Input
          placeholder='Product Name'
          value={productName}
          onChange={onProductNameChange}
          disabled={loading}
          maxLength={50}
          showCount
          multiline
          rows={1}
          style={{ resize: 'none' }}
        />
      </Detail>
      <Detail label='Product Description' style={{ marginBottom: '8px' }}>
        <Input
          placeholder='Enter a short description about the product'
          value={productDescription || ''}
          onChange={onProductDescriptionChange}
          disabled={loading}
          maxLength={500}
          multiline
          autoSize={{ minRows: 1, maxRows: 10 }}
          showCount
        />
      </Detail>
      {showMeetingTime && (
        <Detail style={{ marginBottom: '8px' }} label={<>Date Of Visit</>}>
          <Input
            placeholder='Date Of Visit'
            value={meetingTime}
            disabled={loading}
            onChange={onMeetingTimeChange}
            maxLength={50}
            showCount
            multiline
            rows={1}
            style={{ resize: 'none' }}
          />
        </Detail>
      )}
    </>
  );
}

ProductInfo.propTypes = {
  productName: PropTypes.string,
  productDescription: PropTypes.string,
  meetingTime: PropTypes.string,
  showMeetingTime: PropTypes.bool,
  onProductNameChange: PropTypes.func.isRequired,
  onProductDescriptionChange: PropTypes.func.isRequired,
  onMeetingTimeChange: PropTypes.func,
  loading: PropTypes.bool,
};

ProductInfo.defaultProps = {
  showMeetingTime: false,
  meetingTime: '',
  productName: '',
  productDescription: '',
};

export default ProductInfo;
